<template>
	<!-- <transition name="modal" >
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
						<div class="modal-container" @click.stop>

							<div class="modal-header" style="justify-content: flex-end;">
								<button type="button" class="close" @click="$emit('closeModal')">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							 -->
              <div>
                <!-- <h3 class="text-center mt-2">Aging Stock In Range : {{range}}</h3> -->

                  <!-- <button class="btn btn-success mt-3 mb-3" @click="exportExcel()">Export To Excel</button> -->

                  <table class="table tableBodyScroll text-center">
                      <thead class="">
                          <th>No.</th>
                          <th>No. Mesin</th>
                          <th>Kode Tipe</th>
                          <th>Nama Pasar</th>
                          <th>Kode Warna</th>
                          <th>Aging</th>
                          <th>Production Years</th>
                          <th>Region</th>
                          <th>Warehouse</th>
                          <th>Tgl Masuk</th>
                      </thead>
                      <tbody v-if="data">
                          <tr  v-for="(dat,index) in data" :key="index">
                              <td>{{index + 1}}</td>
                              <td>{{dat.no_mesin}}</td>
                              <td>{{dat.kode_tipe}}</td>
                              <td>{{dat.nama_pasar}}</td>
                              <td>{{dat.kode_warna}}</td>
                              <td>{{dat.aging}} Days</td>
                              <td>{{dat.production_years}}</td>
                              <td>{{dat.region}}</td>
                              <td>{{dat.warehouse}}</td>
                              <td>{{dat.tanggal_masuk}}</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
						<!-- </div>
					</div>
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
				</div>
			</div>
		</div>
	</transition> -->
</template>

<script>
// Charts
// Library
import moment from 'moment'
const XLSX = require('xlsx')
export default {
    props:['location' , 'agingRange' , 'filter'],
    components: {
    },
    data () {
      return {
              moment: moment,
              data : null,
              range : '',
              monthFilter : [{
                name : '1 Month',
                var : 'month_1'
              },{
                name : '2 Months',
                var : 'month_2'
              },{
                name : '3 Months',
                var : 'month_3'
              },{
                name : '3 - 6 Months',
                var : 'month_3_6'
              },{
                name : '> 6 Months',
                var : 'month_6'
              }]
      }
    },
	watch : {
		agingRange : function () {
			this.loadTable()
		}
	},
    mounted () {
        this.loadTable()

        this.range = this.agingRange.split('month_')[1]

        this.range = this.range.includes('_') ? this.range.split('_').join(' - ') + ' Month' : this.range == '6' ? '> ' + this.range + ' Month' :  '< ' + this.range + ' Month'
    },
    methods : {
        async loadTable () {
            let url = `/api/highlight/aging-stock-analysis/table?location=${this.location}&month=${this.agingRange}`

            let filter = await this.initialiseFilter(this.filter)

            this.$http.get(url + filter)
            .then((resp) => {
                this.data = resp.data.data
                // console.log(this.data)
            })
            .catch((err)=> { console.log(err) })

            
        },
        initialiseFilter (filter) {
            let filterString = '&'
            let keys = Object.keys(filter)
            // console.log(filter)

            for(var i = 0 ;  i < keys.length  ; i++) {
                if(filter[keys[i]] != '')
                filterString += `${keys[i]}=${filter[keys[i]]}&`
            }

            return filterString
        },
        export() {
            let wb = XLSX.utils.book_new()
            var ws = XLSX.utils.json_to_sheet(this.data, { raw: "true" });
            XLSX.utils.book_append_sheet(wb, ws, 'Data')
            XLSX.writeFile(wb, `${this.monthFilter.find(x => x.var == this.agingRange).name} Aging Stock.xls`)
        }
    }
}
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 1020;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
  }

  .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
  }

  .modal-container {
      width: 100%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
      margin-top: 0;
      color: #42b983;
  }

  .modal-body {
      margin: 20px 0;
  }

  .modal-default-button {
      float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
      opacity: 0;
  }

  .modal-leave-active {
      opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
      margin:0
  }

  .modal-body .moduleLine{
      margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
      text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
      background-color: #E0E0E0;
      transition: background-color 0.7s ease;
      color: #212121;
      transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
      border:1px solid #BDBDBD;
      border-radius: 20px;
      padding: 20px 0;
      color:black;
      margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
      font-size:5vh;
  }

  h3.modalHeadline{
      margin:0 0 20px 0;
      font-weight: bold;
      text-align : center;
  }
  /* MODAL ENDS */

  .button_outer_box{
    padding:30px;
  }
  .button_inner_box{
    border:1px solid #E0E0E0;
    border-radius:15px;
    box-shadow:5px 5px 15px 1px;
    width: 100%;
    padding-top: 100%; /* 1:1 Aspect Ratio */
    position: relative; /* If you want text inside of it */
  }
  .button_inner_box:hover{
    cursor: pointer;
  }

  .button_text{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .slightlyGray{
    color:#424242
  }

  .hoverBig{
    -webkit-animation: hoverBig 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    animation: hoverBig 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  }
  .unHoverBig{
    -webkit-animation: unHoverBig 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    animation: unHoverBig 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  }
  @-webkit-keyframes hoverBig {
    0% {
      -webkit-transform: scale(1);
              transform: scale(1);
    }
    100% {
      -webkit-transform: scale(1.1);
              transform: scale(1.1);
    }
  }
  @keyframes hoverBig {
    0% {
      -webkit-transform: scale(1);
              transform: scale(1);
    }
    100% {
      -webkit-transform: scale(1.1);
              transform: scale(1.1);
    }
  }
  @-webkit-keyframes unHoverBig {
    0% {
      -webkit-transform: scale(1.1);
              transform: scale(1.1);
    }
    100% {
      -webkit-transform: scale(1);
              transform: scale(1);
    }
  }
  @keyframes unHoverBig {
    0% {
      -webkit-transform: scale(1.1);
              transform: scale(1.1);
    }
    100% {
      -webkit-transform: scale(1);
              transform: scale(1);
    }
  }
	h5 {
		font-weight: bold;
	}
	p {
		padding-left: 10px;
		font-size: 15px;
	}
	td {
		font-size: 15px;
	}
    table.tableBodyScroll tbody {
        display: block;
        max-height: 400px;
        overflow-y: scroll;
    }

    table.tableBodyScroll thead, table.tableBodyScroll tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }
</style>